import PropTypes from "prop-types";
import Wrapper from "../../components/helpers/Wrapper";

const MaleIcon = ({ className, percentage }) => {
    const percent_string = +Math.abs(percentage).toFixed(2).replace(/\.0$/, "") + "%";
    const fill = +Math.abs(100 - percentage).toFixed(2).replace(/\.0$/, "") + "%";

    let bodyFill;

    bodyFill = <Wrapper>
        {percentage > 49 ?
            <Wrapper>
                <stop offset={percent_string} stopColor="#11A1FD" />
                <stop offset={fill} stopColor="#CEDFE8" />
            </Wrapper>
            :
            percentage < 25 ?
                <Wrapper>
                    <stop offset={fill} stopColor="#CEDFE8" />
                    <stop offset={percent_string} stopColor="#CEDFE8" />
                </Wrapper>
                :
                <Wrapper>
                    <stop offset={percent_string} stopColor="#11A1FD" />
                    <stop offset={"20%"} stopColor="#CEDFE8" />
                    <stop offset={"20%"} stopColor="#CEDFE8" />
                    <stop offset={"20%"} stopColor="#CEDFE8" />
                    <stop offset={"20%"} stopColor="#CEDFE8" />
                </Wrapper>
        }
    </Wrapper>

    let headFill;

    if (percentage > 10) {
        headFill = "#11A1FD";
    } else {
        headFill = "#CEDFE8";
    }

    return (
        <svg className={className} height="350px" width="200px"  viewBox="0 0 17 34" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id="malegradientFill" gradientTransform="rotate(90)">
                    {bodyFill}
                </linearGradient>
            </defs>
            <path fill="url('#malegradientFill')" d="M4.443 17.988C4.187 18.671 3.949 19.362 3.669 20.035C3.57116 20.2965 3.3951 20.5215 3.1648 20.6793C2.93451 20.8371 2.66117 20.9201 2.382 20.917C2.11023 20.9328 1.83983 20.8682 1.60455 20.7312C1.36928 20.5943 1.17953 20.3911 1.059 20.147C0.965234 19.9812 0.907824 19.7974 0.890582 19.6078C0.873341 19.4181 0.896662 19.227 0.958998 19.047C1.70766 16.7463 2.45666 14.4463 3.206 12.147C3.41866 11.4963 3.632 10.8463 3.846 10.197C3.92132 9.82394 4.13068 9.49139 4.43451 9.26218C4.73834 9.03298 5.11559 8.92299 5.495 8.953C7.71833 8.93234 9.942 8.92734 12.166 8.938C12.563 8.90918 12.957 9.02491 13.2753 9.26384C13.5936 9.50277 13.8148 9.84878 13.898 10.238C14.84 13.091 15.767 15.95 16.727 18.797C16.8423 19.043 16.8879 19.3159 16.8588 19.5861C16.8297 19.8562 16.7271 20.1132 16.5621 20.329C16.3971 20.5448 16.176 20.7113 15.923 20.8102C15.67 20.9091 15.3946 20.9367 15.127 20.89C14.8722 20.8437 14.6348 20.7293 14.4399 20.5588C14.2449 20.3884 14.0998 20.1683 14.02 19.922C13.82 19.397 13.628 18.869 13.428 18.344C13.4165 18.2724 13.3908 18.2038 13.3523 18.1423C13.3138 18.0808 13.2634 18.0277 13.204 17.986V18.708C13.204 22.7867 13.204 26.8653 13.204 30.944C13.2191 31.207 13.1809 31.4702 13.0916 31.718C13.0023 31.9658 12.8637 32.1929 12.6843 32.3858C12.5049 32.5786 12.2883 32.7331 12.0476 32.84C11.8069 32.947 11.5471 33.0041 11.2837 33.0079C11.0204 33.0118 10.759 32.9623 10.5153 32.8624C10.2715 32.7626 10.0505 32.6145 9.86558 32.427C9.68061 32.2395 9.53551 32.0165 9.439 31.7714C9.34248 31.5263 9.29656 31.2643 9.304 31.001C9.292 28.667 9.304 26.333 9.304 24.001C9.29034 23.7435 9.29234 23.4853 9.31 23.228C9.354 22.874 9.21 22.812 8.883 22.804C8.524 22.796 8.438 22.904 8.44 23.255C8.455 25.773 8.451 28.292 8.447 30.81C8.48831 31.2611 8.37595 31.7129 8.12817 32.0921C7.88038 32.4713 7.51171 32.7557 7.082 32.899C6.77262 32.9943 6.44462 33.0125 6.12661 32.9519C5.80861 32.8913 5.51025 32.7539 5.25758 32.5515C5.00491 32.3491 4.8056 32.088 4.67703 31.7909C4.54847 31.4938 4.49455 31.1697 4.52 30.847C4.512 28.292 4.52 25.736 4.52 23.181V17.992H4.446" />
            <path fill={headFill} d="M4.72198 4.80898C4.73791 3.70771 5.18629 2.65687 5.97033 1.88335C6.75437 1.10983 7.81116 0.675674 8.91254 0.674623C10.0139 0.673573 11.0716 1.10571 11.8571 1.87774C12.6426 2.64976 13.093 3.69974 13.111 4.80098C13.097 5.91016 12.6462 6.96909 11.8563 7.74793C11.0664 8.52676 10.0013 8.96265 8.89198 8.96098C7.78898 8.96152 6.73074 8.52482 5.94911 7.74657C5.16749 6.96832 4.72622 5.91197 4.72198 4.80898" />
        </svg>
    )
}

MaleIcon.propTypes = {
    className: PropTypes.string,
    percentage: PropTypes.number,
}

export default MaleIcon;
